import FiveIntoFive from 'assets/images/psp/Bicycle/5x5.svg';
import FiveIntoTen from 'assets/images/psp/Bicycle/5x10.svg';
import TenIntoTen from 'assets/images/psp/Bicycle/10x10.svg';
import BicycleHeroSize from 'assets/images/psp/Bicycle/bicycle-hero-size.webp';
import Organization from 'assets/images/psp/Bicycle/organization.svg';
import Security from 'assets/images/psp/Bicycle/security.svg';
import Seasonal from 'assets/images/psp/Bicycle/seasonal.svg';
import Locker from 'assets/images/psp/Bicycle/locker.svg';
import CompareCost from 'assets/images/psp/Bicycle/compare-cost.svg';
import YearRound from 'assets/images/psp/Bicycle/year-round.svg';
import SharedStorage from 'assets/images/psp/Bicycle/shared-storage.svg';
import PrepareBikeStorage from 'assets/images/psp/Bicycle/how-to-prepare-bike-for-storage.webp';
import DIYGarage from 'assets/images/psp/Bicycle/DIY-Garage.webp';
import ShutterStock from 'assets/images/psp/ATV/shutterstock.webp';
import Bicycle from 'assets/images/psp/Bicycle/bicycle.webp';

import { storageCategories } from 'pages/PSPPage/utils/getPSPLinks';

const bicycleStorageReviews = [
	{
		title: 'Very satisfied customer',
		stars: 5,
		text: 'Everyone in the office was very nice and helpful. They showed me the unit which was very nice, gave me the code and I was able to put my bike in it.',
		customerName: 'Elly Morrissette',
		date: 'Jun 23, 2022',
		link: 'https://www.trustpilot.com/reviews/62b348d79d448e2f5a51a9a6',
	},
	{
		title: 'Safe and clean',
		stars: 5,
		text: 'I made a reservation online for one price with AAA, but the manager there gave me an even smaller unit at a lower price. It worked out very well for me. It is a gated facility with a security code for each customer. They also had locks. She walked me through how everything worked and was very kind. I rented a 3x5x8 just for suitcases, a few boxes and a bicycle. I recommend this storage place. I found them on selfstorage.com.',
		customerName: 'Customer Schulte',
		date: 'May 28, 2016',
		link: 'https://www.trustpilot.com/reviews/5748b25e0000ff00095fd5aa',
	},
	{
		title: 'Best 1st Impression',
		stars: 5,
		text: 'I have had multiple units in the past but this was by far the best. The rep was able to search for a location fitting my needs and booked me an appointment the same day. I showed up and the associates at Smart Shop Self Storage in Huntington Beach were extremely nice and helpful. I was able to get the perfect unit to store my motorcycle, and it was very affordable! Best first impression I’ve had to date.',
		customerName: 'Anthony Hainsworth',
		date: 'Oct 23, 2019',
		link: 'https://www.trustpilot.com/reviews/5daf9ec16048580988adc0f0',
	},
	{
		title: 'This site is awesome!',
		stars: 5,
		text: 'This site is awesome. I needed to store my motorcycle for the winter and of course, like most people I waited till the last minute to do so. spent a couple hours running around town only to find out that no one had available units. Jumped on selfstorage.com and found the perfect unit in minutes. Saved me a bunch of time and energy. Great site',
		customerName: 'Ron Yoak',
		date: 'Nov 20, 2018',
		link: 'https://www.trustpilot.com/reviews/5bf444779d3780035820669e',
	},
];

const bikeSelfStorageFAQs = [
	{
		question: 'Can I store multiple bikes in one unit?',
		answer: 'Absolutely! Most cyclists find that a 5x10 unit comfortably accommodates 3-4 bikes plus gear, while a 10x10 unit can handle larger families or serious cycling collections. The key is smart organization and choosing the right storage methods like wall hooks or bike stands to maximize space efficiently.',
	},
	{
		question:
			"What's the difference between bike lockers and storage units?",
		answer: 'Bike lockers are smaller, outdoor storage solutions designed specifically for 1-2 bicycles, typically costing $25-45 monthly with drive-up convenience. Storage units offer more space, weather protection, and often climate control, ranging from $40-125 monthly depending on size and features. Choose lockers for budget storage and frequent access, units for valuable bikes and extensive gear.',
	},
	{
		question: 'How do I know if I need climate controlled storage?',
		answer: 'Climate control is worth the investment for e-bikes, carbon fiber bikes, bikes over $1,500, or if you live in areas with high humidity or extreme temperature swings. It prevents rust, protects electronic components, and maintains optimal conditions for premium materials. Regular steel bikes in moderate climates often do fine in standard indoor units.',
	},
	{
		question: 'Can I access my bike storage unit anytime?',
		answer: 'Access hours vary by facility, with many offering 24/7 access while others have specific hours (typically 6 AM to 10 PM). Consider your riding schedule when choosing – if you’re an early morning cyclist or like evening rides, 24-hour access might be worth seeking out, especially during peak cycling seasons.',
	},
	{
		question: 'What security should I expect from bike storage?',
		answer: 'Professional storage facilities typically offer gated access, security cameras, individual unit locks, and on-site management. Many cyclists add their own bike locks inside units for extra security. Look for facilities with good lighting, secure perimeters, and ask about their security protocols and any bike-specific theft protection policies.',
	},
	{
		question: 'Is it worth storing bikes during winter?',
		answer: 'Winter storage makes excellent sense for road bikes, expensive equipment, or if you switch to different bikes seasonally. It protects bikes from road salt, moisture, and temperature extremes while freeing up home space for winter gear. Many cyclists store their primary bikes and keep one winter-ready bike accessible at home.',
	},
];

export const BicycleContent = {
	type: 'Bicycle',
	reviews: bicycleStorageReviews,
	sections: [
		{
			title: 'Bicycle Storage Hero',
			background: 'default',
			modules: [
				{
					type: 'hero',
					props: {
						content: {
							title: 'Find Affordable Bicycle Self Storage',
							description:
								"Your bike shouldn't be competing with your car for garage space or turning your entryway into an obstacle course. Whether it's that sleek road bike you saved up for, the family cargo bike that hauls everything, or your teenager's mountain bike taking over the basement, [every bicycle deserves proper storage](https://www.selfstorage.com/blog/how-to-store-bicycles-and-cycling-gear/) that keeps it safe, accessible, and out of your daily living space.\n\n" +
								"Between theft concerns, weather damage, and the sheer awkwardness of storing something that's six feet long and refuses to stack neatly, finding the right bicycle storage solution can feel overwhelming.\n\n" +
								"**SelfStorage.com** connects you with storage facilities offering everything from compact bike lockers to spacious units perfect for your entire family's cycling gear.",
							image: BicycleHeroSize,
							CTAtext: 'Find Bicycle Self Storage',
							storageType: 'Bicycle',
						},
					},
				},
			],
		},

		// Content Section
		{
			title: 'Stop Spinning Your Wheels: Bicycle Storage Makes Perfect Sense',
			noPaddingBottom: true,
			background: 'lighterBlue',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Stop Spinning Your Wheels: Bicycle Storage Makes Perfect Sense',
						contentType: 'row-type',
						theme: 'light',
						content: [
							`When you're juggling [home organization](https://www.selfstorage.com/blog/how-storage-reduces-cost-of-living), family needs, and protecting valuable equipment, bicycle storage units solve multiple problems at once. Here's how the right storage solution transforms both your space and your cycling experience:`,
						],
					},
				},
			],
		},

		// SizeGuide
		{
			title: 'Benefits of Bike Self Storage',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Benefits of Bike Self Storage',
						description:
							'Not sure about putting your bike into self storage? Don’t worry - here are just a few of many benefits for proper bike self storage:',
						cardData: [
							{
								title: 'Space & Organization Benefits',
								content:
									'A single bike takes up 6-8 square feet of floor space. Transform cluttered garages, hallways, and basements back into functional spaces.',
								imageSrc: Organization,
								contentAlign: 'text-left',
							},
							{
								title: 'Security & Protection',
								content:
									'Indoor bicycle storage provides [climate control](https://www.selfstorage.com/blog/what-is-climate-controlled-storage-2/) that prevents rust, protects electronic components on e-bikes, and keeps your investment in pristine condition.',
								imageSrc: Security,
								contentAlign: 'text-left',
							},
							{
								title: 'Seasonal Flexibility',
								content:
									'Store winter gear during summer months, rotate between road and mountain bikes, or keep that expensive carbon fiber bike safe during off-season.',
								imageSrc: Seasonal,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		// SizeGuide
		{
			title: 'Bicycle Storage Unit Size Guide',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Bicycle Storage Unit Size Guide',
						description:
							'Here’s a quick guide on the bicycle self storage unit sizes available to you:',
						cardData: [
							{
								title: 'Bike Locker (Outdoor)',
								content:
									'**Bike Capacity:** 1-2 standard bikes\n\n' +
									'**Perfect For:** Commuter bikes, budget storage\n\n' +
									'**Monthly Cost Range:** $25-45\n\n' +
									'**Best Choice If:** You need affordable, drive-up access for regular use',
								imageSrc: Locker,
								contentAlign: 'text-left',
							},
							{
								title: '5x5 Storage Unit',
								content:
									'**Bike Capacity:** 1-2 bikes + gear\n\n' +
									'**Perfect For:** Single cyclist, basic accessories\n\n' +
									'**Monthly Cost Range:** $40-65\n\n' +
									'**Best Choice If:** You want indoor protection for one quality bike plus helmets, tools, and seasonal gear',
								imageSrc: FiveIntoFive,
								contentAlign: 'text-left',
							},
							{
								title: '5x10 Storage Unit',
								content:
									'**Bike Capacity:** 3-4 bikes + extensive gear\n\n' +
									'**Perfect For:** Families, cycling enthusiasts\n\n' +
									'**Monthly Cost Range:** $60-85\n\n' +
									'**Best Choice If:** You have multiple bikes or need space for maintenance supplies and cycling accessories',
								imageSrc: FiveIntoTen,
								contentAlign: 'text-left',
							},
							{
								title: '10x10 Storage Unit',
								content:
									'**Bike Capacity:** 5+ bikes + workshop space\n\n' +
									'**Perfect For:** Collectors, maintenance setup\n\n' +
									'**Monthly Cost Range:** $85-125\n\n' +
									'**Best Choice If:** You want room for a bike collection, repair workspace, or extensive family cycling gear',
								imageSrc: TenIntoTen,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		// Content Section
		{
			title: 'Space-Saving Pro Tips',
			background: 'blueWithMap',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Space-Saving Pro Tips',
						contentType: 'row-type',
						theme: 'dark',
						content: [
							'- Measure bikes with pedals, baskets, and any attached accessories\n' +
								'- [Vertical storage](https://www.selfstorage.com/blog/vertical-closet-storage-organization-space-saving-hacks/) using wall hooks can double your capacity\n' +
								'- Consider bike stands for easy organization and access\n' +
								'- Leave room for seasonal gear rotation',
						],
					},
				},
			],
		},

		// SizeGuide
		{
			title: 'Budget-Smart Storage Tips',
			modules: [
				{
					type: 'cardStrip',
					props: {
						heading: 'Budget-Smart Storage Tips',
						description:
							'Looking for a self storage deal? Here’s the best way to ensure you’re getting the most out of your bicycle self storage unit.',
						cardData: [
							{
								title: 'Compare Total Costs',
								content:
									'Factor in setup fees, security deposits, and any additional charges. Sometimes a slightly more expensive unit with better features offers better value than the cheapest option.',
								imageSrc: CompareCost,
								contentAlign: 'text-left',
							},
							{
								title: 'Seasonal vs. Year-Round',
								content:
									'Consider whether you need storage [year-round or just seasonally](https://www.selfstorage.com/blog/long-term-vs-short-term-storage-guide/). Some facilities offer discounts for longer commitments, while others work better for short-term needs.',
								imageSrc: YearRound,
								contentAlign: 'text-left',
							},
							{
								title: 'Shared Storage Options',
								content:
									'Some cyclists split larger units with friends or neighbors. A 10x10 unit shared between two families can be more economical than separate smaller units.',
								imageSrc: SharedStorage,
								contentAlign: 'text-left',
							},
						],
					},
				},
			],
		},

		// Video Content Section
		{
			title: 'Essential Bicycle Prep for Storage Success',
			background: 'blueGradient',
			modules: [
				{
					type: 'video',
					props: {
						content: {
							title: 'Essential Bicycle Prep for Storage Success',
							imageSrc: PrepareBikeStorage,
							suffixText: `Taking time to properly prepare your bike for storage can save hundreds in repairs and keep everything running smoothly when you're ready to ride again.`, //
						},
					},
				},
			],
		},

		//Reviews Section
		{
			title: 'Reviews Section',
			noPaddingBottom: true,
			background: 'lighterBlue',
			modules: [
				{
					type: 'reviews',
					props: {
						reviewsData: {
							slug: 'bike-reviews',
							headerTitle: 'Bike Self Storage: ',
							reviews: bicycleStorageReviews,
						},
					},
				},
			],
		},

		// FAQs

		{
			title: 'Bike Self Storage FAQs',
			modules: [
				{
					type: 'faqs',
					props: {
						content: {
							header: 'Bike Self Storage FAQs',
							faqs: bikeSelfStorageFAQs,
						},
					},
				},
			],
		},
		// Related COntent
		{
			title: 'Featured Content',
			background: 'darkBlue',
			modules: [
				{
					type: 'featuredContent',
					props: {
						data: {
							heading: 'Learn All About Bicycle Self Storage',
							type: 'unitCards',
							id: 'storage size unit cards',
							data: {
								slug: 'Bike-featured-content',
								unitCards: [
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/how-to-store-bicycles-and-cycling-gear/',
										layout: false,
										plain: true,
										date: 'October 16, 2025',
										image: Bicycle,
										content:
											'Everything You Need to Know about Storage Solutions for Bicycles',
									},
									{
										title: 'Storage Tips',
										url: 'https://www.selfstorage.com/blog/outdoor-gear-shed-storage-unit/',
										layout: false,
										plain: true,
										date: 'October 16, 2025',
										image: ShutterStock,
										content:
											'Sports Equipment Storage Guide: How to Create a Sports and Outdoor Gear Storage Room',
									},
									{
										title: 'DIY Home & Organization',
										url: 'https://www.selfstorage.com/blog/diy-garage-storage/',
										layout: false,
										plain: true,
										date: 'October 29, 2025',
										image: DIYGarage,
										content:
											'9 DIY Garage Storage Ideas to Maximize Space and Declutter',
									},
								],
							},
						},
					},
				},
			],
		},

		// More Ways to Store
		{
			title: 'Link to other PSPs',
			background: 'lighterBlue',
			modules: [
				{
					type: 'links',
					props: {
						heading: {
							headingName: 'More ways to store',
						},
						linksList: storageCategories.bicycle,
					},
				},
			],
		},

		// Near By cities
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
					props: {
						type: 'Bicycle',
					},
				},
			],
		},
	],
};
